// extracted by mini-css-extract-plugin
export var quantityInput = "_fe-0";